import { useIdeas } from '@hooks'
import React from 'react'
import { EventCreateOrigin, useOpenEventCreate } from './EventCreateFlow'
import ImportIdeaModal from './ImportIdeaModal'

export interface PickIdeaDialogProps {
	tripId: string
	/** The Trip day the picked idea goes on; null while no idea is being picked. */
	dayIndex: number | null
	/** Where the create-event flow returns to. */
	from: EventCreateOrigin
	onClose: () => void
}

/**
 * Coming from the idea board: the idea picker, whose pick opens the
 * create-event flow on the asked-for day, filled in from the idea. Shared by
 * every surface that offers "Import idea".
 */
const PickIdeaDialog: React.FC<PickIdeaDialogProps> = ({ tripId, dayIndex, from, onClose }) => {
	const { data: ideasData } = useIdeas(tripId)
	const openEventCreate = useOpenEventCreate(tripId, from)

	return (
		<ImportIdeaModal
			isOpen={dayIndex !== null}
			onClose={onClose}
			onNext={idea => {
				if (dayIndex !== null) openEventCreate(dayIndex, idea.id)
			}}
			ideas={ideasData?.ideas ?? []}
		/>
	)
}

export default PickIdeaDialog
